var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonExercise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 22,
    viewBox: "0 0 13 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 4C8.6 4 9.5 3.1 9.5 2C9.5 0.9 8.6 0 7.5 0C6.4 0 5.5 0.9 5.5 2C5.5 3.1 6.4 4 7.5 4ZM3.8 7.4L1 21.5H3.1L4.9 13.5L7 15.5V21.5H9V14L6.9 12L7.5 9C8.8 10.5 10.8 11.5 13 11.5V9.5C11.1 9.5 9.5 8.5 8.7 7.1L7.7 5.5C7.3 4.9 6.7 4.5 6 4.5C5.7 4.5 5.5 4.6 5.2 4.6L0 6.8V11.5H2V8.1L3.8 7.4Z",
    fill: "#FDFDFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonExercise);
export default __webpack_public_path__ + "static/media/person-exercise.274be6ef6e16cd9b67cf660b271931e9.svg";
export { ForwardRef as ReactComponent };